import { format } from "date-fns";
import constants from "./constants";
import { Base64 } from "js-base64";

export const printVal = (val) => {};

export const delay = (ms) => new Promise((res) => setTimeout(res, ms));
export const convertToBase64String = (data) => {    
  return Base64.encode(data).replace("0x", ",").replace("0X",".");
}
export function dateFormatWithTime(text) {
  var formatted = " - ";
  try {
    formatted = format(new Date(text ?? "-"), "d/M/yyyy  h:mm a");
    return formatted;
  } catch (e) {
    return formatted;
  }
}
export function dateFormatWithoutTime(text) {
  var formatted = " - ";
  try {
    formatted = format(new Date(text ?? "-"), "d/M/yyyy");
    return formatted;
  } catch (e) {
    return formatted;
  }
}
export function removeDomainFromEmail(email) {
  // Split the email string by "@" symbol
  const parts = email.split("@");

  // If there are more than one part (meaning "@" is present)
  if (parts.length > 1) {
    // Remove the domain part (the last part after "@")
    parts.pop();
  }

  // Join the parts back together
  return parts.join("@");
}
// Function to decode the JWT token
export function decodeJWTToken(token, property) {
  var propertyVal = null;
  try {
    const tokenParts = token.split(".");
    const header = JSON.parse(atob(tokenParts[0]));
    const payload = JSON.parse(atob(tokenParts[1]));
    const signature = tokenParts[2]; // This is usually used for validation, but we're not using it here
    propertyVal = payload[property];
  } catch (error) {
    console.error("Error decoding token:", error);
  }
  return propertyVal;
}
export function isDev() {
  return constants.env_ === "Dev";
}
